export default __webpack_public_path__ + "static/media/photo1.e0284c39.jpg";